module.exports = __webpack_public_path__ + "img/targetOff.81ad0c4c.svg";